module.exports = __webpack_public_path__ + "static/james-2ff63f1b57e029510098d8f10e16523f.svg";